export default "__VITE_ASSET__tGqVaO6k__"